// extracted by mini-css-extract-plugin
export default {"preview":"rTfvtg","emptyState":"n8Q5io","colorGrid":"Fe4cSx","colorColumn":"JWDupG","colorItem":"uMdW_T"};